import { useEffect, useRef } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import "react-multi-date-picker/styles/colors/red.css";
import { numberToENG } from "../../tools/functions/Methods";
interface PropType {
  title?: string;
  handleChange?: any;
  name?: string;
  values?: any;
  time?: boolean;
  timeName?: string;
  timeValues?: any;
  error?: any;
  important?: boolean;
  WrapperClassName?: string;
  Now?: boolean;
  readOnly?: boolean;
  onlyMonthPicker?: boolean;
  minDate?: any;
}

const MultiDatePicker = ({
  title,
  name,
  values,
  handleChange,
  time,
  timeValues,
  timeName,
  error,
  important,
  WrapperClassName,
  Now,
  readOnly,
  onlyMonthPicker,
  minDate,
}: PropType) => {
  const timePlugin = [<TimePicker position="bottom" hideSeconds />];
  const datePickerRef = useRef(undefined);

  // const convertToDateObject = (value: any) => {
  //   if (!value) return null;

  //   // اگر مقدار string است (مثلاً "1404/03")
  //   if (typeof value === "string") {
  //     const [year, month] = value.split("/");
  //     return new DateObject({
  //       calendar: persian,
  //       locale: persian_fa,
  //       year: Number(year),
  //       month: Number(month),
  //     });
  //   }

  //   // اگر مقدار یک آبجکت است (مثلاً {year: 1404, month: 3})
  //   return new DateObject({
  //     calendar: persian,
  //     locale: persian_fa,
  //     ...value,
  //   });
  // };

  useEffect(() => {
    if (Now) {
      const NowDate = new Date().toLocaleDateString("fa-IR").split("/");
      handleChange(name, {
        day: Number(numberToENG(NowDate[2])),
        month: Number(numberToENG(NowDate[1])),
        year: Number(numberToENG(NowDate[0])),
      });
    }
  }, [Now, handleChange, name]);


  
  const convertToDateObject = (date: { year: number; month: number; day: number }) => {
    if (!date) return undefined;
    return new DateObject({
      year: date.year,
      month: date.month,
      day: date.day,
      calendar: persian,
    });
  };

  return (
    <div
      className={`flex flex-col multi  Max-md:w-full dateClass ${WrapperClassName}`}
    >
      <div
        className={`relative   rounded-lg w-full ${readOnly && "opacity-40"}`}
      >
        <div
          className={`autocompleteLabel  ${error && "text-red"} z-10 -top-4`}
        >
          {title}{" "}
          <span className="text-tomato font-extrabold text-lg h-4">
            {important ? "*" : " "}
          </span>
        </div>
        <DatePicker
          minDate={convertToDateObject(minDate)}
          onlyMonthPicker={onlyMonthPicker}
          disabled={readOnly}
          className="red z-0 !focus:shadow-none  "
          calendar={persian}
          name={name}
          value={
            time
              ? `${
                  values?.year + "/" + values?.month + "/" + values?.day
                } ${timeValues}`
              : onlyMonthPicker
              ?convertToDateObject(values)
              : `${values?.year + "/" + values?.month + "/" + values?.day}`
          }
          locale={persian_fa}
          format={
            time
              ? `YYYY/MM/DD HH:mm`
              : onlyMonthPicker
              ? "YYYY/MM"
              : "YYYY/MM/DD"
          }
          calendarPosition="bottom-right"
          // placeholder={`${values?.day} / ${values?.month} / ${values?.year}       ${time && `${timeValues?.hour}:${timeValues?.minute}`}`}
          onChange={(date: any) => {
            handleChange(name, {
              day: Number(date.day),
              month: Number(date.month),
              year: Number(date.year),
            });
            time && handleChange(timeName, date.hour + ":" + date.minute);
          }}
          // render={<InputIcon />}
          plugins={time ? timePlugin : []}
          ref={datePickerRef}
        />
      </div>
      {
        <style>{`
            .multi .rmdp-input:focus {
              box-shadow: none !important;
          }
    `}</style>
      }
    </div>
  );
};

MultiDatePicker.defaultProps = {
  WrapperClassName: "w-60",
};

export default MultiDatePicker;
